module.exports = __webpack_public_path__ + "img/jxl.0745935b.svg";